import { useEffect, useState } from 'react'
import { fetchClinicOpeningHoursApi } from '@services/api/clinic-opening-hours.api'
import { logger } from '@utils/safeLogger'

const NO_CLOSED_DAYS: ReadonlySet<string> = new Set()

/** Weekday names ("Sunday", ...) the clinic is closed on, from Opening hours. */
export const useClinicClosedWeekdays = (
  clinicId: string,
): ReadonlySet<string> => {
  const [closedWeekdays, setClosedWeekdays] =
    useState<ReadonlySet<string>>(NO_CLOSED_DAYS)

  useEffect(() => {
    if (!clinicId) {
      setClosedWeekdays(NO_CLOSED_DAYS)
      return
    }
    let cancelled = false
    fetchClinicOpeningHoursApi(clinicId)
      .then((response) => {
        if (cancelled) return
        const schedule = response.data?.opening_hours?.schedule ?? []
        setClosedWeekdays(
          new Set(
            schedule
              .filter((row) => !row.is_open)
              .map((row) => row.day_of_week),
          ),
        )
      })
      .catch((error) => {
        if (cancelled) return
        logger.error('Error loading clinic opening hours:', error)
        setClosedWeekdays(NO_CLOSED_DAYS)
      })
    return () => {
      cancelled = true
    }
  }, [clinicId])

  return closedWeekdays
}
